export default __webpack_public_path__ + "static/webRotator/svg/e403280172540901b6a611d43133613a.svg";